
<template>
    <div class="dropdown-box">
        <label>{{ step.label }} <span class="text-red-500">{{ required ? '&#x2A;' : '' }}</span> </label>
        <select v-model="dropdownVal" @change="dropdownValue" class="form-dropdown">
            <option  v-for="element in step.valueList" :key="element.value" :value="element.value">{{ element.name }}</option>
        </select>
    </div>
</template>

<script>
export default {
    props: {
        step: {
            type: Object,
            required: true
        },
        value: {
            type: String,
            required: true
        },
        required: {
            type: Boolean, 
            required: false,
            default: false
        }
    },
    data(){
        return{
            dropdownVal: ''
        }
    },
    methods: {
        dropdownValue(){
            this.$emit('input', {'value': this.dropdownVal, 'valid': true})
        }
    }

}
</script>

<style lang="scss" scoped>
.form-dropdown {
    width: 100%;
    height: 100%;
    padding: 15px .8em 16px;
    border: 2px solid #0384FB;
    box-sizing: border-box;
    color: #302f32;
}


</style>